import * as React from 'react'
import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import Button from '@eversports/klimt-primitives/Button'
import Processing from '@eversports/klimt-primitives/Processing'
import Text from '@eversports/klimt-primitives/Text'

import { PublicUser } from '../../../../PublicUserProfile.types'
import {
  FriendshipRequestedPendingPublicUserDocument,
  useFriendshipRequestedPendingAcceptFriendRequestMutation,
} from '../../../../../../graphql'
import { Localized } from '../../../../../../localization/react'

interface Props {
  friend: PublicUser
}

const FriendshipRequestedPending = ({ friend }: Props) => {
  const { amplitude } = useAmplitude()
  const [approveFriendRequest, { loading }] = useFriendshipRequestedPendingAcceptFriendRequestMutation({
    variables: { userId: friend.id },
    refetchQueries: [
      {
        query: FriendshipRequestedPendingPublicUserDocument,
        variables: { handle: friend.handle },
      },
    ],
  })

  const handleClick = () => {
    if (amplitude) {
      amplitude.logEvent('Clicked Approve Received Friend Request Button')
    }
    void approveFriendRequest()
  }

  return (
    <Processing isLoading={loading}>
      <Button
        variant="secondary"
        sx={{ textTransform: 'none', paddingY: { xs: 3, md: 2 }, paddingX: 6, width: 'fit-content' }}
        onClick={handleClick}
      >
        <Text sx={{ color: 'primary.main', fontWeight: 'bold' }}>
          <Localized id="accept-friend-request" />
        </Text>
      </Button>
    </Processing>
  )
}

export default FriendshipRequestedPending
